// extracted by mini-css-extract-plugin
export default {"wrapdiv":"footer_wrapdiv__pmskU","logos":"footer_logos__T2mq3","flex":"footer_flex__u6b7e","flexx":"footer_flexx__0RP20","first":"footer_first__eRFJ8","pro":"footer_pro__2fJEY"};